<template>
  <!-- 活动详情 -->
  <div id="eventdetalis" ref="container">
    <!-- 头部导航 -->
    <div class="title_nav">
      <div>
        <Icon @click="$router.replace({ path: '/' })" name="arrow-left" style="margin-top:0.1rem" />
      </div>
      <div class="nav_address">{{ title }}</div>
    </div>
    <!-- 页面头部图片 -->
    <div class="title_img">
      <img :src="titleImg" alt="">
    </div>
    <div class="content" v-for="item in descriptionList" :key="item.id">
      <div class="details" @click="$router.push({ path: '/detail/' + item.id })">
        <div>
          <img :src="item.image" alt="" />
        </div>
        <div class="words">
          <div class="description1">{{ item.store_name }}</div>
          <div class="description2"></div>
          <div class="description3">
            <div class="ption">
              <div><img src="@/assets/images/icon-money.png" alt=""></div>
             <div> {{ item.price }}</div>
            </div>
            <div class="icon" @click="Packageaddition(item)">
              <Icon name="plus" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loadend && descriptionList.length !== 0" class="page-text-center over-tip">已加载完成</div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
  </div>
</template>
<script>
import { Icon, } from "vant";
import { hotSales, brandSelection } from "@api/activity.js";
import Loading from "@components/Loading";
import debounce from "lodash.debounce";
export default {
  name: "eventdetalis",
  components: {
    Loading,
    Icon
  },
  data() {
    return {
      // 页面列表数据
      descriptionList: [],
      // 请求列表传参
      data: {
        page: 1,
        limit: 10
      },
      loading: false,
      loadend: false,
      title: '',
      titleImg: '',
      scrollY: 0,
    };
  },
  mounted() {
    this.getHomeZxList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getHomeZxList();
    }, this.scrollHander)
  },
  activated: function () {
    this.$nextTick(() => {
      window.scrollBy({ top: this.scrollY, left: 0 });
    })
  },
  methods: {
    scrollHander(e) {
      const scrollY = e.scrollY;
      this.scrollY = scrollY;
    },
    //列表数据
    getHomeZxList : debounce(function(){
      if (this.$route.query.type == 1) {
        this.title = '热门商品'
        var that = this;
        if (that.loading) return; //阻止下次请求（false可以进行请求）；
        if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
        that.loading = true;
        let q =this.data
        hotSales(q).then(res => {
          that.loading = false
          that.titleImg = res.data.backgroundImg
          that.descriptionList.push.apply(that.descriptionList,res.data.hotSales)
          that.loadend = res.data.hotSales.length < that.data.limit; //判断所有数据是否加载完成；
          that.data.page = that.data.page + 1;
        });
      } else {
        this.title = '品牌商品'
        var that = this;
        if (that.loading) return; //阻止下次请求（false可以进行请求）；
        if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
        that.loading = true;
        let q=this.data
        brandSelection(q).then(res => {
          that.loading = false
          that.titleImg = res.data.backgroundImg
          that.descriptionList.push.apply(that.descriptionList,res.data.brandSelection)
          that.loadend = res.data.brandSelection.length < that.data.limit; //判断所有数据是否加载完成；
          that.data.page = that.data.page + 1;
        });
      }
    }) 
  },

};
</script>
<style scoped>
.title_nav {
  display: flex;
  width: 100%;
  background: white;
  height: 0.7rem;
  padding-left: 0.2rem;
  padding-top: 0.15rem;
}

.nav_address {
  width: 80%;
  text-align: center;
  margin-left: 0.4rem;
  padding-top: 0.05rem;
}

.content {
  width: 92%;
  margin: 0.3rem 0.3rem;
  background: white;
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
}

.details {
  display: flex;
  margin-top: 0.3rem;
}

.details img {
  width: 2rem;
  height: 2rem;
}

.words {
  margin-left: 0.2rem;
  width: 100%;
}

.description1 {
  height: 1.05rem;
    font-size: 0.25rem;
    margin-top: -0.05rem;
  font-family: PingFang SC-Heavy, PingFang SC;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.description2 {
  margin-top: 0.2rem;
/* height: 0.35rem; */
  color: #757575;
}

.description3 {
  margin-top: 0.6rem;
  display: flex;
  justify-content: space-between;
  color: #ee453e;
}

.description3 span {
  font-size: 0.2rem;
}

.ption {
  font-size: 0.3rem;
  margin-top: 0.1rem;
  display: flex;
}
.ption img{
  width: 0.35rem;
  height: 0.35rem;
  margin-top: -0.01rem !important;
}
.icon {
  width: 0.5rem;
  height: 0.5rem;
  background: #ee453e;
  text-align: center;
  line-height: 0.5rem;
  color: white;
  font-weight: 800;
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
  border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
}


.title_img {
  width: 100%;
  height: 100%;
}

.title_img img {
  width: 100%;
  height: 100%;
}
.over-tip {
  line-height: 1rem;
  color: #868686;
}
</style>
  